import { render, staticRenderFns } from "./TkChange.vue?vue&type=template&id=bc7e9b2c&scoped=true&"
import script from "./TkChange.vue?vue&type=script&lang=js&"
export * from "./TkChange.vue?vue&type=script&lang=js&"
import style0 from "./TkChange.vue?vue&type=style&index=0&id=bc7e9b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e9b2c",
  null
  
)

export default component.exports